import StickyNav from '../components/StickyNav';
import LightBox from '../components/LightBox';
import Accordion from '../components/Accordion';
import {
    galleryFilters,
    resetAllFilters,
    updateFilters,
} from '../components/GalleryFilter';
import GalleryVideoPlayers from '../components/GalleryVideoPlayers';

const photosIntColorPanel = document.getElementById('js-photo-interior-panel') as HTMLElement;
const photosExtColorPanel = document.getElementById('js-photo-exterior-panel') as HTMLElement;
const photosLivingSpacePanel = document.getElementById('js-livingspace-interior-panel') as HTMLElement;

const intColorButtons = photosIntColorPanel.querySelectorAll<HTMLButtonElement>(
    '.js-btn-filter[data-filtertype="intcolor"]',
);

const extColorButtons = photosExtColorPanel.querySelectorAll<HTMLButtonElement>(
    '.js-btn-filter[data-filtertype="extcolor"]',
);

const livingSpaceButtons = photosLivingSpacePanel.querySelectorAll<HTMLButtonElement>(
    '.js-btn-filter[data-filtertype="livingspace"]',
);

const toggleColorPanels = (
    panelTypeToHide: 'interior' | 'exterior' | 'all',
) => {
    
    switch (panelTypeToHide) {
        case 'interior':
            photosExtColorPanel.classList.remove('inactive'); // Enable exterior panel
            photosIntColorPanel.classList.add('inactive'); // Add inactive class
            photosLivingSpacePanel.classList.add('inactive'); // Add inactive class
            resetDependentButtons('interior');
            break;
        case 'exterior':
            photosExtColorPanel.classList.add('inactive'); // Add inactive class
            photosIntColorPanel.classList.remove('inactive'); // Enable interior panel
            photosLivingSpacePanel.classList.remove('inactive'); // Add inactive class
            resetDependentButtons('exterior');
            break;
        default:
            photosExtColorPanel.classList.remove('inactive'); // Add inactive class
            photosIntColorPanel.classList.remove('inactive'); // Enable interior panel
            photosLivingSpacePanel.classList.remove('inactive'); // Add inactive class
            break;
    }
};

const resetDependentButtons = (panelToReset: 'interior' | 'exterior' | 'all') => {
    switch (panelToReset) {
        case 'interior':
            
            if (photosIntColorPanel) {
                intColorButtons.forEach(button => {
                    button.classList.remove('active'); // Remove active class
                    if (button.dataset.filter === 'all') {
                        button.classList.add('active');
                    }
                });
            }

            if (photosLivingSpacePanel) {
                livingSpaceButtons.forEach(button => {                    
                    button.classList.remove('active'); // Remove active class
                    if (button.dataset.filter === 'all') {
                        button.classList.add('active');
                    }
                });
            }

            break;
        case 'exterior':
            
            if (photosExtColorPanel ) {
                extColorButtons.forEach(button => {
                    button.classList.remove('active'); // Remove active class
                    if (button.dataset.filter === 'all') {
                        button.classList.add('active');
                    }
                });
            }
            break;        
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // Sticky nav initialization    
    const stickyNav = StickyNav();
    stickyNav.init();

    LightBox();
    Accordion('js-photos-accordion', true);
    
    GalleryVideoPlayers.initPlayers();

    // Attach event listeners to filter buttons
    document.querySelectorAll('.js-btn-filter').forEach(button => {
        button.addEventListener('click', event => {
            const target = event.currentTarget as HTMLElement;
            const valueType = target.dataset.filtertype; // Get the filter type from the button
            const value = target.dataset.filter; // Get the value from the button

            if (!target || !valueType || !value) return; // Exit if invalid

            const parentContainer = target.parentElement;
            console.log(parentContainer);
            if (!parentContainer) return;

            let assetType = parentContainer.dataset.type || '';

            // Update the corresponding filter value
            switch (valueType) {
                case 'plan':
                    galleryFilters.planValue = value;
                    const seriesId = target.dataset.id;

                    // Reset all buttons if "all" is clicked
                    if (value === 'all') {

                        if (photosLivingSpacePanel) {
                            livingSpaceButtons.forEach(button => {
                                button.removeAttribute('disabled'); // Enable all living space buttons
                                button.classList.remove('active'); // Remove active class

                                if (button.dataset.filter === 'all') {
                                    button.classList.add('active');
                                }
                            });
                        }

                        if (photosIntColorPanel) {
                            intColorButtons.forEach(button => {
                                button.removeAttribute('disabled'); // Enable all interior color buttons
                                button.classList.remove('active'); // Remove active class

                                if (button.dataset.filter === 'all') {
                                    button.classList.add('active');
                                }

                            });
                        }

                        if (photosExtColorPanel) {
                            extColorButtons.forEach(button => {
                                button.removeAttribute('disabled'); // Enable all exterior color buttons
                                button.classList.remove('active'); // Remove active class

                                if (button.dataset.filter === 'all') {
                                    button.classList.add('active');
                                }
                            });
                        }

                        toggleColorPanels('all');

                    } else if (assetType === 'photo' && value !== 'all') {
                        // Fetch data from API if plan is selected and value is not "all"
                        fetch(`/api/gallery/series-rooms/${seriesId}`)
                            .then(response => response.json())
                            .then((data: string[]) => {

                                if (photosLivingSpacePanel) {
                                    livingSpaceButtons.forEach(button => {
                                        const buttonValue = button.getAttribute('data-filter');
                                        // Disable buttons if their value is not in the returned data
                                        if (buttonValue && buttonValue !== 'all') {
                                            if (!data.includes(buttonValue)) {
                                                button.setAttribute('disabled', 'true');
                                            } else {
                                                button.removeAttribute('disabled');
                                            }
                                        } else if (buttonValue === 'all') {
                                            // Ensure the "All" button is always enabled
                                            button.removeAttribute('disabled');
                                        }
                                    });
                                }

                                if (photosIntColorPanel) {
                                    intColorButtons.forEach(button => {
                                        const buttonValue = button.getAttribute('data-filter');
                                        // Disable buttons if their value is not in the returned data
                                        if (buttonValue && buttonValue !== 'all') {
                                            if (!data.includes(buttonValue)) {
                                                button.setAttribute('disabled', 'true');
                                            } else {
                                                button.removeAttribute('disabled');
                                            }
                                        } else if (buttonValue === 'all') {
                                            // Ensure the "All" button is always enabled
                                            button.removeAttribute('disabled');
                                        }
                                    });
                                }

                                if (photosExtColorPanel) {
                                    extColorButtons.forEach(button => {
                                        const buttonValue = button.getAttribute('data-filter');
                                        // Disable buttons if their value is not in the returned data
                                        if (buttonValue && buttonValue !== 'all') {
                                            if (!data.includes(buttonValue)) {
                                                button.setAttribute('disabled', 'true');
                                            } else {
                                                button.removeAttribute('disabled');
                                            }
                                        } else if (buttonValue === 'all') {
                                            // Ensure the "All" button is always enabled
                                            button.removeAttribute('disabled');
                                        }
                                    });
                                }


                            })
                            .catch(error => console.error('Error fetching room data:', error));
                    }
                    break;

                case 'livingspace':
                    galleryFilters.livingSpaceValue = value;
                    galleryFilters.extColorValue = 'all';
                    if (galleryFilters.intColorValue === 'all' && galleryFilters.livingSpaceValue === 'all') {
                        toggleColorPanels('all');
                    } else {
                        toggleColorPanels('exterior'); // Hide exterior panel if an interior color is selected
                    }
                    break;

                case 'intcolor':
                    galleryFilters.intColorValue = value;
                    galleryFilters.extColorValue = 'all'; // Reset exterior when interior is selected

                    if (galleryFilters.intColorValue === 'all' && galleryFilters.livingSpaceValue === 'all') {
                        toggleColorPanels('all');
                    } else {
                        toggleColorPanels('exterior'); // Hide exterior panel if an interior color is selected
                    }                    
                    break;

                case 'extcolor':
                    galleryFilters.extColorValue = value;
                    galleryFilters.intColorValue = 'all'; // Reset interior when exterior is selected
                    galleryFilters.livingSpaceValue = 'all';
                    if (value !== 'all') {
                        toggleColorPanels('interior'); // Hide interior panel if an exterior color is selected
                    } else {
                        toggleColorPanels('all');
                    }
                    break;

                default:
                    console.warn(`Unknown filter type: ${valueType}`);
                    return; // Exit if the filter type is unknown
            }

            // Call the update function to refresh the displayed images
            updateFilters(assetType);

            // Remove active class from all buttons of the same type and add to the clicked one
            parentContainer
                .querySelectorAll(`button[data-filtertype="${valueType}"]`)
                .forEach(btn => {
                    btn.classList.remove('active'); // Remove active class from all buttons of the same type
                });
            target.classList.add('active'); // Add active class to the clicked button

            GalleryVideoPlayers.stopPlaying();

            stickyNav.refresh();
        });
    });

    // Attach event listeners to reset all buttons
    document.querySelectorAll<HTMLButtonElement>('.js-reset-all').forEach(button => {
        button.addEventListener('click', () => {
            const filterType = button.dataset.type;
            if (!filterType) return;
            if (filterType === 'photo') {
                toggleColorPanels('all');
            }
            resetAllFilters(filterType);
        });
    });

    //button to toggle mobile filter view
    document.querySelectorAll<HTMLButtonElement>('.js-btn-toggle-mobile-filters').forEach(button => {
        button.addEventListener('click', () => {
            const filterContainer = document.getElementById('js-photo-filter');

            if (filterContainer) {
                filterContainer.classList.toggle('active');
                document.body.classList.toggle('m-overflow');
            }
        });
    });
});
